// @flow
import { createReducer, createActions } from 'reduxsauce'
import { currentCurrency } from '../../src/Utils/PrivilegeUtils'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  presetChange: ['data'],
  
  currencyRequest: null,
  currencySuccess: ['data'],
  currencyFailure: ['err'],

  languageRequest: null,
  languageSuccess: ['data'],
  languageFailure: ['err'],

  countriesRequest: null,
  countriesSuccess: ['data'],
  countriesFailure: ['err'],

  presetOrderRequest: null,
  presetOrderSuccess: ['data'],
  presetOrderFailure: ['err'],

  presetOrderUpdateRequest: ['data'],
  presetOrderUpdateSuccess: ['data'],
  presetOrderUpdateFailure: ['err'],

  getBranchRequest: null,
  getBranchSuccess: ['data'],
  getBranchFailure: ['err'],

  updateBranchRequest: ['data'],
  updateBranchSuccess: ['data'],
  updateBranchFailure: ['err'],

  getShipping: null,
  getShippingSuccess: ['data'],
  getShippingFailure: ['err'],

  updateShipping: ['data'],
  updateShippingSuccess: ['data'],
  updateShippingFailure: ['err']
})

export const PresetTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetchingCurrency: false,
  errCurrency: null,
  dataCurrency: [],

  fetchingLanguage: false,
  errLanguage: null,
  dataLanguage: [],

  fetchingCountries: false,
  errCountries: null,
  dataCountries: [],

  fetchingPresetOrder: false,
  errPresetOrder: null,
  dataPresetOrder: {},

  fetchingBranch: false,
  errBranch: null,
  dataBranch: {},

  fetchingShipping: false,
  errShipping: null,
  dataShipping: {},

  setting: {
    currency_code: currentCurrency(),
    language_code: 'EN',
    provider: 'BMG'
  }
})

/* ------------- Reducers ------------- */
// Currency
export const currencyRequest = (state: Object) => state.merge({
  fetchingCurrency: true,
  errCurrency: null
})

export const currencySuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetchingCurrency: false,
    errCurrency: null,
    dataCurrency: data
  })

export const currencyFailure = (state: Object, {err}: any) => {
  return state.merge({
    fetchingCurrency: false,
    errCurrency: err
  })
}

// Language
export const languageRequest = (state: Object) => state.merge({
  fetchingLanguage: true,
  errLanguage: null
})

export const languageSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetchingLanguage: false,
    errLanguage: null,
    dataLanguage: data
  })

export const languageFailure = (state: Object, { err }: any) => {
  return state.merge({
    fetchingLanguage: false,
    errLanguage: err
  })
}

// Countries
export const countriesRequest = (state: Object) => state.merge({
  fetchingCountries: true,
  errCountries: null
})

export const countriesSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetchingCountries: false,
    errCountries: null,
    dataCountries: data
  })

export const countriesFailure = (state: Object, { err }: any) => {
  return state.merge({
    fetchingCountries: false,
    errCountries: err
  })
}

// Preset Order
export const presetOrderRequest = (state: Object) => state.merge({
  fetchingPresetOrder: true,
  errPresetOrder: null
})

export const presetOrderUpdateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetchingPresetOrder: false,
    errPresetOrder: null
  })

export const presetOrderSuccess = (state: Object, { data }: Object) =>
  state.merge({
    fetchingPresetOrder: false,
    errPresetOrder: null,
    dataPresetOrder: data
  })

export const presetOrderFailure = (state: Object, { err }: any) => {
  return state.merge({
    fetchingPresetOrder: false,
    errPresetOrder: err
  })
}

export const change = (state: Object, {data}: Object) => {
  return state.merge({
    setting: data
  })
}

// Branch
export const getBranchRequest = (state: Object) => state.merge({ fetchingBranch: true, errBranch: null })
export const getBranchSuccess = (state: Object, { data }: Object) => state.merge({ fetchingBranch: false, errBranch: null, dataBranch: data })
export const getBranchFailure = (state: Object, { err }: any) => state.merge({ fetchingBranch: false, errBranch: err })

export const updateBranchRequest = (state: Object) => state.merge({ fetchingBranch: true, errBranch: null })
export const updateBranchSuccess = (state: Object, { data }: Object) => state.merge({ fetchingBranch: false, errBranch: null, dataBranch: data })
export const updateBranchFailure = (state: Object, { err }: any) => state.merge({ fetchingBranch: false, errBranch: err })

// Shipping
export const getShipping = (state: Object) => state.merge({ fetchingShipping: true, errShipping: null })
export const getShippingSuccess = (state: Object, { data }: Object) => state.merge({ fetchingShipping: false, errShipping: null, dataShipping: data })
export const getShippingFailure = (state: Object, { err }: any) => state.merge({ fetchingShipping: false, errShipping: err })

export const updateShipping = (state: Object) => state.merge({ fetchingShipping: true, errShipping: null })
export const updateShippingSuccess = (state: Object, { data }: Object) => state.merge({ fetchingShipping: false, errShipping: null, dataShipping: data })
export const updateShippingFailure = (state: Object, { err }: any) => state.merge({ fetchingShipping: false, errShipping: err })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer =
  createReducer(INITIAL_STATE, {
    [Types.PRESET_CHANGE]: change,

    [Types.CURRENCY_REQUEST]: currencyRequest,
    [Types.CURRENCY_SUCCESS]: currencySuccess,
    [Types.CURRENCY_FAILURE]: currencyFailure,

    [Types.LANGUAGE_REQUEST]: languageRequest,
    [Types.LANGUAGE_SUCCESS]: languageSuccess,
    [Types.LANGUAGE_FAILURE]: languageFailure,

    [Types.COUNTRIES_REQUEST]: countriesRequest,
    [Types.COUNTRIES_SUCCESS]: countriesSuccess,
    [Types.COUNTRIES_FAILURE]: countriesFailure,

    [Types.PRESET_ORDER_REQUEST]: presetOrderRequest,
    [Types.PRESET_ORDER_SUCCESS]: presetOrderSuccess,
    [Types.PRESET_ORDER_FAILURE]: presetOrderFailure,

    [Types.PRESET_ORDER_UPDATE_REQUEST]: presetOrderRequest,
    [Types.PRESET_ORDER_UPDATE_SUCCESS]: presetOrderUpdateSuccess,
    [Types.PRESET_ORDER_UPDATE_FAILURE]: presetOrderFailure,

    [Types.GET_BRANCH_REQUEST]: getBranchRequest,
    [Types.GET_BRANCH_SUCCESS]: getBranchSuccess,
    [Types.GET_BRANCH_FAILURE]: getBranchFailure,

    [Types.UPDATE_BRANCH_REQUEST]: updateBranchRequest,
    [Types.UPDATE_BRANCH_SUCCESS]: updateBranchSuccess,
    [Types.UPDATE_BRANCH_FAILURE]: updateBranchFailure,

    [Types.GET_SHIPPING]: getShipping,
    [Types.GET_SHIPPING_SUCCESS]: getShippingSuccess,
    [Types.GET_SHIPPING_FAILURE]: getShippingFailure,

    [Types.UPDATE_SHIPPING]: updateShipping,
    [Types.UPDATE_SHIPPING_SUCCESS]: updateShippingSuccess,
    [Types.UPDATE_SHIPPING_FAILURE]: updateShippingFailure
  })



// WEBPACK FOOTER //
// ./src/Redux/PresetRedux.js